module.exports = __webpack_public_path__ + "img/Error.184a4331.svg";